import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {AuthenticateModalProps} from '@Modals/authenticate-modal/authenticate-modal';

export const openAuthenticateModal = (props: AuthenticateModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.AUTHENTICATE_MODAL,
      panelProps: props,
    })
  );
};
